
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VideoPayment from "../pages/video-payment/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/video-payment",
    element: <VideoPayment />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
